import { memo, useRef } from "react";
//import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { Outlet } from "infrastructure/router";
import { useModal } from "ui/atoms/Modal";
import { when } from "util/support";

const ECommerceOutlet = () => {
    const drawer = useModal();
    const drawerRef = useRef(drawer);
    drawerRef.current = drawer;

    // useEffect(() => {
    //     const timeout = setTimeout(drawerRef.current.onOpen, 1000);

    //     return () => clearTimeout(timeout);
    // }, []);

    return (
        <>
            <Box
                sx={{
                    transition: 'margin 0.3s ease-in-out',
                    mr: when(
                        drawer.open,
                        23,
                        0
                    )
                }}
            >
                <Outlet />
            </Box>
            {/* TODO: Uncomment when the drawer content is ready
            <Drawer
                PaperProps={{
                    sx: {
                        mt: '88px'
                    }
                }}
                variant='persistent'
                anchor='right'
                open={drawer.open}
            >
                Useful links and resources
            </Drawer> */}
        </>
    );
};

export default memo(ECommerceOutlet);
